import { render, staticRenderFns } from "./PortalAllShops.vue?vue&type=template&id=f936ead6&scoped=true&"
import script from "./PortalAllShops.vue?vue&type=script&lang=js&"
export * from "./PortalAllShops.vue?vue&type=script&lang=js&"
import style0 from "./PortalAllShops.vue?vue&type=style&index=0&id=f936ead6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f936ead6",
  null
  
)

export default component.exports